module.exports = __webpack_public_path__ + "media/assets/Campaign-3faf549e97b383b548b0141648469e29.svg";